import { render, staticRenderFns } from "./detailLike.vue?vue&type=template&id=75233ef6&scoped=true&"
import script from "./detailLike.vue?vue&type=script&lang=ts&"
export * from "./detailLike.vue?vue&type=script&lang=ts&"
import style0 from "./detailLike.vue?vue&type=style&index=0&id=75233ef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75233ef6",
  null
  
)

export default component.exports